'use strict';

var tabtable = angular.module('gymsystem.tabtable', []);

tabtable.directive('tabtable', [function () {
    return {
        restrict: 'E',
        templateUrl: 'views/tabtable.html',
        scope: {
            config: '='
        },
        link: function(scope) {
            var initCalled = false;
            function configChanged(activeTab) {
                var config = angular.copy(scope.config);
                var first = _.find(scope.config.tabs, function(tab) { return !tab.configOverride; });
                angular.forEach(scope.config.tabs, function(tab) {
                    tab.config = angular.copy(config);
                    if (tab.configOverride) {
                        tab.config = tab.configOverride;
                    }
                    tab.config.itemFilter = tab.itemFilter;
                    tab.config.visible = tab.visible;
                    tab.config.name = tab.name;
                    tab.config.context = tab.context;
                    if (!tab.configOverride) {
                        tab.config.filter = scope.config.filter;  // link to source filter
                    }
                    tab.config.empty = tab.empty;
                    tab.config.bannerDirective = tab.bannerDirective;

                    if (tab != first && tab.config.api && !tab.configOverride) {
                        tab.config.getItems = function() {
                            if (first.config.getItems) {
                                tab.config.getItems = first.config.getItems;
                            }

                            if (tab.config.getItems) {
                                return tab.config.getItems();
                            }
                        };
                    }
                });

                scope.config.control = {};
                scope.config.control.getNumberOfItems = function() {
                    if (!scope.config.tabs) {
                        return 0;
                    }
                    return _.reduce(scope.config.tabs.filter(function(tab) { return !tab.configOverride; }), function(sum, tab) { return sum + (tab.config.control ? tab.config.control.getNumberOfItems() : 0); }, 0);
                };

                scope.config.control.update = function() {
                    angular.forEach(scope.config.tabs, function(tab) {
                        if (tab.config.control) {
                            tab.config.control.update();
                        }
                    });
                };

                scope.config.control.rebuild = function() {
                    angular.forEach(scope.config.tabs, function(tab) {
                        if (tab.config.control) {
                            tab.config.control.rebuild();
                        }
                    });
                };

                scope.config.control.setActiveTab = function(tab) {
                    scope.config.tabs.forEach(function(ftab) {
                        ftab.active = tab == ftab;
                    });
                };

                scope.config.control.getActiveTab = function() {
                    return _.find(scope.config.tabs, function(tab) { return tab.active; });
                };

                scope.config.control.getTab = function(name) {
                    return _.findWhere(scope.config.tabs, { name: name });
                };

                if (!initCalled && scope.config.onInit) {
                    initCalled = true;
                    scope.config.onInit();
                } else {
                    if (activeTab && activeTab.config.context && activeTab.config.context.id) {
                        activeTab = _.find(scope.config.tabs, function(tab) { return tab.context && tab.context.id == activeTab.config.context.id; });
                        if (activeTab) {
                            scope.config.control.setActiveTab(activeTab);
                        }
                    }
                }
            }

            scope.$watch('config', function(newValue, oldValue) {
                if (newValue) {
                    var activeTab = oldValue ? _.findWhere(oldValue.tabs, {active: true}) : null;
                    configChanged(activeTab);
                }
            });

            function hasInactiveHiddenTab() {
                if (scope.config && scope.config.hideEmptyTabs) {
                    var activeTab = _.findWhere(scope.config.tabs, {active: true});
                    if (activeTab && activeTab.config && activeTab.config.control && activeTab.config.control.getNumberOfItems && !activeTab.config.control.getNumberOfItems()) {
                        var tab = _.find(scope.config.tabs, function(tab) {
                            return tab.config && tab.config.control && tab.config.control.getNumberOfItems && tab.config.control.getNumberOfItems();
                        });
                        if (tab) {
                            return {toFocus: tab, toBlur: activeTab};
                        }
                    }
                }
            }

            scope.$watch(hasInactiveHiddenTab, function(tabs) {
                if (tabs) {
                    tabs.toFocus.active = true;
                    tabs.toBlur.active = false;
                }
            });
        }
    };
}]);
